export default ({request}) => ({
  changeOrderDocListApi(data = {}) {
    return request({
      url: '/factory/change/order/doc/list',
      method: 'post',
      data,
    })
  },
  changeOrderDocDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/doc/detail',
      method: 'post',
      data,
    })
  },
  changeOrderDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/change/order/doc/batch/upload',
      method: 'post',
      data,
    })
  },
  changeOrderDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/change/order/doc/batch/del',
      method: 'post',
      data,
    })
  },
  changeOrderDocUpdateApi(data = {}) {
    return request({
      url: '/factory/change/order/doc/update',
      method: 'post',
      data,
    })
  },
})
